export default {
    categories: {
         "cine-series": {
             name: 'Cine & Series©',
             category: 'cine-series',
             id: 2347
         },
         musica: {
             name: 'Música',
             category: 'musica',
             id: 761725657
         },
         "arte-cultura": {
             name: 'Arte & Cultura',
             category: 'arte-cultura',
             id: 761725658
         },
         "entrevistas": {
             name: 'Entrevistas',
             category: 'entrevistas',
             id: 761725659
         },
        "el-absurdo": {
            name: 'El absurdo',
            category: 'el-absurdo',
            id: 761725660
        },
    }
}